import React, {children} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import Home1 from './gallerys/Home-1'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



function slider() {

   return(
    <>
 <Swiper
     modules={[Navigation, Pagination, Scrollbar, A11y]}
     spaceBetween={10}
     slidesPerView={5}
     navigation
     loop={true}
     pagination={{ clickable: true }}
    
     scrollbar={{ draggable: true }}
     
    >
        { Home1.map(Home1 =>{
            return (<SwiperSlide key={Home1.key}> <img className='rounded-lg shadow-xl' src={Home1.src}/> </SwiperSlide>);
        })
        
        }
    </Swiper>
    </>
   );
    
}
export default slider;